<template>
  <v-app-bar app class="primary">
    <v-app-bar-title class="white--text text-no-wrap">
      大交合 2.0
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <mini-weather-card />

    <settings-btn />

  </v-app-bar>
</template>

<script>
import axios from 'axios'
import MiniWeatherCard from '@/components/MiniWeatherCard'

import SettingsBtn from '@/components/SettingsBtn'
export default {
  components: {
    SettingsBtn,
    MiniWeatherCard
  },
}
</script>

<style lang="scss">
.v-app-bar-title__content{
  text-overflow: clip !important;
}
</style>
